import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  alertApiRef,
} from '@backstage/core-plugin-api';
import { toastApiRef } from '@backstage/frontend-plugin-api';

// ToastApi status -> AlertApi severity. `status` defaults to 'success' when unset.
const severityByStatus = {
  success: 'success',
  warning: 'warning',
  info: 'info',
  danger: 'error',
  neutral: 'info',
} as const;

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
  createApiFactory({
    api: toastApiRef,
    deps: { alertApi: alertApiRef },
    factory: ({ alertApi }) => ({
      post(toast) {
        const message =
          typeof toast.title === 'string' ? toast.title : String(toast.title);
        const severity = severityByStatus[toast.status ?? 'success'];
        const display =
          toast.timeout !== undefined ? ('transient' as const) : ('permanent' as const);
        alertApi.post({ message, severity, display });
        return { close: () => {} };
      },
    }),
  }),
];
